import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pgId: null,
};

const pgSlice = createSlice({
  name: 'pg',
  initialState,
  reducers: {
    setPgId: (state, action) => {
      state.pgId = action.payload;
    },
  },
});

export const { setPgId } = pgSlice.actions;

export default pgSlice.reducer;